module.exports = __webpack_public_path__ + "Group2.png";